import {h, Fragment} from "preact"
import { useState } from "preact/hooks"

const toggles = ['Measurements', 'Clothing', 'Shoes', 'Swim'];

export default function SizeGuide({ sizeGuideOpen, setSizeGuideOpen }) {
    const [ activeToggle, setActiveToggle ] = useState(0);

    return (
        <section 
            class={`collection-size-guide pdp-main-cols ${sizeGuideOpen ? "visible" : ""}`} 
            style="display: none;"
            data-active-guide={activeToggle}
        >
            <div class="pdp-main__size-guide">
                <button 
                    class="pdp-main__size-guide-close"
                    type="button"
                    onClick={() => setSizeGuideOpen(false)}
                >
                    <span></span><span></span>
                </button>
                <p class="pdp-main__size-guide-title h3">Size Guide</p>

                <div class="pdp-main__size-guide-wrap">
                    <ul class="pdp-main__size-guide-nav">
                        {toggles.map((toggle, index) => (
                            <li class="pdp-main__size-guide-category" key={toggle}>
                                <button
                                    type="button"
                                    onClick={() => setActiveToggle(index)}
                                >
                                    {toggle}
                                </button>
                            </li>
                        ))}
                    </ul>

                    <div class="pdp-main__size-guide-chart-wrap">
                        <div class="pdp-main__size-guide-table-wrap">
                            <div class="pdp-main__size-guide-table-inner">
                                <div class="pdp-main__size-guide-table-scroll">
                                    <table class="pdp-main__size-guide-chart pdp-main__size-guide-chart--long-y-heading">
                                        <tbody>
                                            <tr>
                                                <th></th>
                                                <th>
                                                    XS<br />
                                                    0-2
                                                </th>
                                                <th>
                                                    S<br />
                                                    2-4
                                                </th>
                                                <th>
                                                    M<br />
                                                    6-8
                                                </th>
                                                <th>
                                                    L<br />
                                                    8-10
                                                </th>
                                                <th>
                                                    XL<br />
                                                    10-12
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>Torso*</th>
                                                <td>15.75</td>
                                                <td>16</td>
                                                <td>16.25</td>
                                                <td>16.5</td>
                                                <td>16.75</td>
                                            </tr>
                                            <tr>
                                                <th>Bust</th>
                                                <td>31.5"-33"</td>
                                                <td>33.5"-35"</td>
                                                <td>35"-36.5"</td>
                                                <td>36.5"-38"</td>
                                                <td>38"-39.5"</td>
                                            </tr>
                                            <tr>
                                                <th>Waist</th>
                                                <td>23.5"-25"</td>
                                                <td>25.5"-27.5"</td>
                                                <td>28"-29.5"</td>
                                                <td>30"-31.5"</td>
                                                <td>32"-33.5"</td>
                                            </tr>
                                            <tr>
                                                <th>Hip</th>
                                                <td>35"-36.5"</td>
                                                <td>37"-38.5"</td>
                                                <td>39"-41.5"</td>
                                                <td>42-43.5"</td>
                                                <td>44"-45.5"</td>
                                            </tr>
                                            <tr>
                                                <th>Thigh</th>
                                                <td>20.5-21.25"</td>
                                                <td>21.25"-22"</td>
                                                <td>22.25"-23"</td>
                                                <td>23.25"-24"</td>
                                                <td>24.25"-25"</td>
                                            </tr>
                                            <tr>
                                                <th>Arm</th>
                                                <td>21.625</td>
                                                <td>22</td>
                                                <td>22.375</td>
                                                <td>22.75</td>
                                                <td>23.125</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div class="pdp-main__size-guide-scrollbar">
                                <span></span>
                            </div> */}
                            <p class="pdp-main__size-guide-disclaimer"><sup>*</sup> Small is measured against a model of 5"8" in size.</p>
                            <p class="pdp-main__size-guide-disclaimer"><sup>**</sup> Size, fit and measurements may vary from one style to another, which means there might be slight differences in items fit.</p>
                        </div>
                        <div class="pdp-main__size-guide-table-wrap">
                            <div class="pdp-main__size-guide-table-inner">
                                <div class="pdp-main__size-guide-table-scroll">
                                    <table class="pdp-main__size-guide-chart pdp-main__size-guide-chart--short-y-heading">
                                        <tbody>
                                            <tr>
                                                <th></th>
                                                <th>XS</th>
                                                <th>S</th>
                                                <th>M</th>
                                                <th>L</th>
                                                <th>XL</th>
                                            </tr>
                                            <tr>
                                                <th>US</th>
                                                <td>0-2</td>
                                                <td>4</td>
                                                <td>6</td>
                                                <td>8</td>
                                                <td>10-12</td>
                                            </tr>
                                            <tr>
                                                <th>UK</th>
                                                <td>6</td>
                                                <td>8</td>
                                                <td>10</td>
                                                <td>12</td>
                                                <td>14</td>
                                            </tr>
                                            <tr>
                                                <th>IT</th>
                                                <td>38</td>
                                                <td>40</td>
                                                <td>42</td>
                                                <td>44</td>
                                                <td>46</td>
                                            </tr>
                                            <tr>
                                                <th>FR</th>
                                                <td>34</td>
                                                <td>36</td>
                                                <td>38</td>
                                                <td>40</td>
                                                <td>42</td>
                                            </tr>
                                            <tr>
                                                <th>AU</th>
                                                <td>6</td>
                                                <td>8</td>
                                                <td>10</td>
                                                <td>12</td>
                                                <td>14</td>
                                            </tr>
                                            <tr>
                                                <th>EU</th>
                                                <td>32</td>
                                                <td>34</td>
                                                <td>36</td>
                                                <td>38</td>
                                                <td>40</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div class="pdp-main__size-guide-scrollbar">
                                <span></span>
                            </div> */}
                            <p class="pdp-main__size-guide-disclaimer"><sup>*</sup> Small is measured against a model of 5"8" in size.</p>
                            <p class="pdp-main__size-guide-disclaimer"><sup>**</sup> Size, fit and measurements may vary from one style to another, which means there might be slight differences in items fit.</p>
                        </div>
                        <div class="pdp-main__size-guide-table-wrap">
                            <div class="pdp-main__size-guide-table-inner">
                                <div class="pdp-main__size-guide-table-scroll">
                                    <table class="pdp-main__size-guide-chart">
                                        <tbody>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                            <tr class="highlighted">
                                                <th>IT</th>
                                                <td>35</td>
                                                <td>35.5</td>
                                                <td>36</td>
                                                <td>36.5</td>
                                                <td>37</td>
                                                <td>37.5</td>
                                                <td>38</td>
                                                <td>38.5</td>
                                                <td>39</td>
                                                <td>39.5</td>
                                                <td>40</td>
                                                <td>40.5</td>
                                                <td>41</td>
                                                <td>41.5</td>
                                                <td>42</td>
                                            </tr>
                                            <tr>
                                                <th>US</th>
                                                <td>5</td>
                                                <td>5.5</td>
                                                <td>6</td>
                                                <td>6.5</td>
                                                <td>7</td>
                                                <td>7.5</td>
                                                <td>8</td>
                                                <td>8.5</td>
                                                <td>9</td>
                                                <td>9.5</td>
                                                <td>10</td>
                                                <td>10.5</td>
                                                <td>11</td>
                                                <td>11.5</td>
                                                <td>12</td>
                                            </tr>
                                            <tr>
                                                <th>UK</th>
                                                <td>2</td>
                                                <td>2.5</td>
                                                <td>3</td>
                                                <td>3.5</td>
                                                <td>4</td>
                                                <td>4.5</td>
                                                <td>5</td>
                                                <td>5.5</td>
                                                <td>6</td>
                                                <td>6.5</td>
                                                <td>7</td>
                                                <td>7.5</td>
                                                <td>8</td>
                                                <td>8.5</td>
                                                <td>9.5</td>
                                            </tr>
                                            <tr>
                                                <th>FR</th>
                                                <td>36</td>
                                                <td>36.5</td>
                                                <td>37</td>
                                                <td>37.5</td>
                                                <td>38</td>
                                                <td>38.5</td>
                                                <td>39</td>
                                                <td>39.5</td>
                                                <td>40</td>
                                                <td>40.5</td>
                                                <td>41</td>
                                                <td>41.5</td>
                                                <td>42</td>
                                                <td>42.5</td>
                                                <td>43</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div class="pdp-main__size-guide-scrollbar">
                                <span></span>
                            </div> */}
                            <p class="pdp-main__size-guide-disclaimer"><sup>*</sup> All Cult Gaia shoe sizes run as Italian (IT).</p>
                        </div>
                        <div class="pdp-main__size-guide-table-wrap">
                            <div class="pdp-main__size-guide-table-inner">
                                <div class="pdp-main__size-guide-table-scroll">
                                    <table class="pdp-main__size-guide-chart pdp-main__size-guide-chart--short-y-heading">
                                        <tbody>
                                            <tr>
                                                <th></th>
                                                <th>XXS</th>
                                                <th>XS</th>
                                                <th>S</th>
                                                <th>M</th>
                                                <th>L</th>
                                            </tr>
                                            <tr>
                                                <th>US</th>
                                                <td>00-00</td>
                                                <td>0-2</td>
                                                <td>2-4</td>
                                                <td>4-6</td>
                                                <td>6-8</td>
                                            </tr>
                                            <tr>
                                                <th>AU</th>
                                                <td>2-4</td>
                                                <td>4-6</td>
                                                <td>6-8</td>
                                                <td>8-10</td>
                                                <td>12+</td>
                                            </tr>
                                            <tr>
                                                <th>UK</th>
                                                <td>2-4</td>
                                                <td>4-6</td>
                                                <td>6-8</td>
                                                <td>8-10</td>
                                                <td>12+</td>
                                            </tr>
                                            <tr>
                                                <th>EU</th>
                                                <td>30-32</td>
                                                <td>32-34</td>
                                                <td>34-36</td>
                                                <td>36-38</td>
                                                <td>40+</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div class="pdp-main__size-guide-scrollbar">
                                <span></span>
                            </div> */}
                            <p class="pdp-main__size-guide-disclaimer"><sup>*</sup> Small is measured against a model of 5"8" in size.</p>
                            <p class="pdp-main__size-guide-disclaimer"><sup>**</sup> Size, fit and measurements may vary from one style to another, which means there might be slight differences in items fit.</p>
                        </div>
                    </div>

                    <div class="pdp-main__size-guide-need-help">
                        <div class="pdp-main__size-guide-message-icon">
                            <svg class="icon icon-cart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.4438 23.6631C13.6627 23.6631 12.9317 23.3507 12.391 22.7856L10.5665 20.8768C10.3859 20.6865 10.132 20.5803 9.86959 20.5803H7.72283C6.15701 20.5803 4.88654 19.3086 4.88654 17.744V7.74862C4.88654 6.1828 6.15823 4.91232 7.72283 4.91232H21.1637C22.7295 4.91232 24 6.18402 24 7.74862V17.7402C24 19.306 22.7283 20.5765 21.1637 20.5765H19.0169C18.7545 20.5765 18.5019 20.6864 18.3201 20.8731L16.4955 22.7819C15.9561 23.3506 15.2249 23.6631 14.4438 23.6631ZM7.72274 6.78549C7.19185 6.78549 6.76104 7.2163 6.76104 7.74719V17.7388C6.76104 18.2697 7.19185 18.7005 7.72274 18.7005H9.8695C10.6408 18.7005 11.3877 19.019 11.9223 19.578L13.7468 21.4868C14.1154 21.8712 14.772 21.8712 15.1406 21.4868L16.9651 19.578C17.496 19.019 18.2466 18.7005 19.0179 18.7005H21.1646C21.6955 18.7005 22.1263 18.2697 22.1263 17.7388V7.74813C22.1263 7.21724 21.6955 6.78643 21.1646 6.78643L7.72274 6.78549Z" fill="#393939"></path>
                                <path d="M2.83752 15.668C1.2717 15.668 0.00122014 14.3963 0.00122014 12.8317L0 2.8363C0 1.27048 1.2717 0 2.8363 0H16.2772C17.843 0 19.1135 1.2717 19.1135 2.8363C19.1135 3.355 18.6949 3.7736 18.1762 3.7736C17.6575 3.7736 17.2389 3.355 17.2389 2.8363C17.2389 2.30541 16.8081 1.8746 16.2772 1.8746H2.83755C2.30666 1.8746 1.87585 2.30541 1.87585 2.8363V12.8279C1.87585 13.3588 2.30666 13.7896 2.83755 13.7896C3.35625 13.7896 3.77485 14.2082 3.77485 14.7269C3.77485 15.2468 3.35497 15.668 2.83752 15.668Z" fill="#393939"></path>
                            </svg>
                        </div>
                        Need more help? Contact us for assistance.
                    </div>
                </div>
            </div>
        </section>
    )
}
